import script from "./CourseItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseItem.vue?vue&type=script&setup=true&lang=js"

import "./CourseItem.vue?vue&type=style&index=0&id=7efc6381&lang=scss"

const __exports__ = script;

export default __exports__